module.exports = __webpack_public_path__ + "static/the-dreamers-f32eeda65b50a676a6b97d26ca9f6b67.jpg";